module.exports = __webpack_public_path__ + "static/media/SG_trans.301423d4.png";